import { Box, Checkbox, TextField } from 'braid-design-system';
import * as styles from './GenericTitleQuestion.css';

type GenericTitleQuestionProps = {
  genericTitleText: string;
  isGenericTitle: boolean;
  onCheckedChange: () => void;
  onTextChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  message?: string;
  tone?: 'critical' | 'neutral';
};

export const GenericTitleQuestion = ({
  genericTitleText,
  isGenericTitle,
  message,
  onCheckedChange,
  onTextChange,
  tone,
}: GenericTitleQuestionProps) => {
  return (
    <>
      <Checkbox
        label="Show a generic title on my review to protect my identity"
        checked={isGenericTitle}
        onChange={onCheckedChange}
      />
      <Box
        aria-hidden={!isGenericTitle}
        className={`${styles.container} ${isGenericTitle ? styles.expanded : ''}`}
      >
        <TextField
          label="Generic title"
          description="E.g. Department or team name"
          value={genericTitleText}
          onChange={onTextChange}
          tone={tone}
          message={message}
        />
      </Box>
    </>
  );
};
